<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <ik-data-table
    :entity-name="$t('cashBook')"
    :icon="'mdi-devices'"
    :model="model"
    :required-date-value="dates"
    :use-date-filter="true"
    :use-default-action="true"
    :use-delete-action="false"
    :use-edit-action="false"
    :use-select="false"
    @reloaded="reload"
  >
    <template #footer="{tableItems}">
      <v-card
        class="ml-2 pa-2 px-4 d-flex"
        color="success--text"
        elevation="0"
        outlined
        style="background: white;border-radius: 24px !important;white-space: nowrap"
      >
        <v-icon
          color="success"
          left
        >
          mdi-arrow-up-bold-box-outline
        </v-icon>
        <div>
          {{ getTotal(tableItems.filter(it => it.payLogAmount > 0)) | priceDisplay }}
        </div>
      </v-card>
      <v-card
        class="ml-2 pa-2 px-4 d-flex align-center"
        color="error--text"
        elevation="0"
        outlined
        style="background: white;border-radius: 24px !important;white-space: nowrap"
      >
        <v-icon
          color="error"
          left
        >
          mdi-arrow-down-bold-box-outline
        </v-icon>
        {{ -1 * getTotal(tableItems.filter(it => lessThanZero(it.payLogAmount))) | priceDisplay }}
      </v-card>
      <v-card
        class="ml-2 mr-2 pa-2 px-4 d-flex align-center"
        elevation="0"
        outlined
        style="background: white;border-radius: 24px !important;white-space: nowrap"
      >
        <v-icon
          left
        >
          mdi-bank
        </v-icon>
        {{ currentAmount| priceDisplay }}
      </v-card>
    </template>
  </ik-data-table>
</template>

<script>

  import CashBook from '../../../../model/bills/cashbook/CashBook'
  import { getCurrentCashAmount, manageCashAccount } from '@/common/Utlis/api'
  import { IkDataTable } from 'metaflow-js'
  import Utils from '../../../../common/Utlis/Utils'
  import { today } from '@/common/Repository/DateRepository'

  const todayDateRange = [today, today]
  export default {
    components: {
      IkDataTable,
    },
    data () {
      return {

        model: CashBook,
        dates: todayDateRange,
        amountCashBook: null,
        amountCashBookSpecial: null,
        amountCashBookInput: null,
        noteCashBook: '',
        noteCashBookSpecial: '',
        noteCashBookInput: '',
        menu: false,
        currentAmount: -1,

      }
    },
    computed: {},
    watch: {},

    async mounted () {
      await this.initialize()
    },
    methods: {
      lessThanZero (item) {
        return item < 0
      },
      getTotal (items) {
        return items.reduce((sum, i) => sum + i.payLogAmount, 0)
      },
      async reload () {
        this.currentAmount = await getCurrentCashAmount()
      },
      async initialize () {
        this.dates = [today, today]
        await this.reload()
      },
      clearInput () {
        this.amountCashBook = 0
        this.amountCashBookSpecial = 0
        this.noteCashBook = ''
        this.noteCashBookSpecial = ''
      },
      async saveCashBook (amount, note, datevAccountRef) {
        if (amount) {
          /**/
          await manageCashAccount(-amount, note, datevAccountRef)
          Utils.toast(this.$t('save_success'))
          await this.initialize()
        } else {
          Utils.showError(this.$t('amount_can_not_be_empty'))
        }

        this.clearInput()
      },
    },
  }

</script>
<style>
.hiddenText {
  display: inline-block;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hiddenText:hover {
  overflow: visible;
}
</style>
